import moment from "moment";
import { convertToPercent, deepCopy, getAppData, getDatesInRange, getFromState, getObjectFilter, getPermissions, getTransformedSegments, in_array, round, setUpDate } from "../../../app/util";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import { useSelector } from "react-redux";
import { transformSegmentData } from "../segmentedData";
import { getSegmentedCode } from "../processDataReports";
import { generatDefaultSubcolumns } from "../../../app/table-config";

/**   */

export const getReportData_biSensitivity = (columns, auth, app_state, ui_state) => {
    console.log("Columns =>> ",columns);
    const useVarCapacity = !!(
        ui_state.showVariableCapacity &&
        getPermissions(auth.profile.property_details, app_state.property_id).permissions?.variable_capacity_enabled
    );
    let biSensitivity_data = dataService.getSeriesById("BiSensitivity").data;
    let data = (biSensitivity_data) ? biSensitivity_data.data : [];
    let setup_data = [];
    if (data && data.length > 0) {
        data.map((item, index) => {
            let data_columns = [];
            columns.map(col => {
                let dataObj = { id: col.id };
                let { mainKey, k } = col;
                if (col.type === 'dateColumn') {
                    dataObj['dba']  = item.index.dba;
                }
                if (col.type === 'dataColumn') {
                    col.subcolumns.map(key => {
                        if (item['HotelTotal'][mainKey]) {
                            const htData = item['HotelTotal'][mainKey];
                            const vCapVC = htData?.VCapacity;
                            const vCap = vCapVC || htData?.Capacity;
                            const capacityForCalc = useVarCapacity ? vCap : htData?.Capacity;
                            if (key.value == "Occ") {
                                dataObj[key.value] = capacityForCalc
                                    ? convertToPercent(htData.Rooms / capacityForCalc)
                                    : convertToPercent(htData[key.value]);
                                if (vCap) {
                                    dataObj._vcap = useVarCapacity ? vCap : htData?.Capacity;
                                    dataObj._vcapLabel = (useVarCapacity && vCapVC) ? 'Variable Capacity' : 'Capacity';
                                    dataObj._vcapDiffers = !!(vCapVC && vCapVC !== htData?.Capacity);
                                }
                            } else if (key.value == "RevPAR") {
                                dataObj[key.value] = capacityForCalc
                                    ? round(htData.Revenue / capacityForCalc)
                                    : htData[key.value];
                            } else if (key.value == "Rooms") {
                                dataObj[key.value] = Math.round(htData[key.value]);
                            } else if (key.value === 'Available') {
                                dataObj[key.value] = (capacityForCalc && htData.Rooms !== undefined) ? round(capacityForCalc - htData.Rooms) : 0;
                            } else {
                                dataObj[key.value] = htData[key.value];
                            }
                        } else {
                            dataObj[key.value] = 0;
                        }
                    })
                }
                data_columns.push(dataObj);
            })
            setup_data.push(data_columns);
        })
    }
    // debugger;
    return setup_data;
}


export const getMaxColumnName = () => {
    let biSensitivity_data = dataService.getSeriesById("BiSensitivity").data;
    let data = (biSensitivity_data) ? biSensitivity_data.data : [];
    let max = 0;
    let allData = {};
    data.map((item,index)=>{
        let len = Object.keys(item.HotelTotal).length;
        if(len > max){
            max = len;
            allData = item.HotelTotal;
        }
    })
    return allData;
}

export const getReportData_biSensitivitySegment = (columns, auth, app_state, ui_state, segmentsTransformed) => {
    const useVarCapacity = !!(
        ui_state.showVariableCapacity &&
        getPermissions(auth.profile.property_details, app_state.property_id).permissions?.variable_capacity_enabled
    );
    let biSensitivity_data = dataService.getSeriesById("BiSensitivity").data;
    let data = (biSensitivity_data) ? biSensitivity_data.data : [];
    let setup_data = [];
    if (data && data.length > 0) {
        data.map((item, index) => {
            let segmentDataOnly = deepCopy(item);

            
            let marketSegmentsCopy = deepCopy(segmentsTransformed.marketSegments);
            marketSegmentsCopy['Total'] = ['Total', 'HotelTotal'];
            Object.keys(marketSegmentsCopy).forEach((marketSegmentsKey) => {
                
                const marketSegmentsGroup = marketSegmentsCopy[marketSegmentsKey];
                
                let segmentGroupRow=[];

                columns.map(col => {
                    let dataObj = { id: col.id };
                    let { mainKey } = col;

                    if (col.type === 'dateColumn') {
                        dataObj['dba']  = segmentDataOnly.index.dba;
                        dataObj["segment"] =  marketSegmentsGroup[0];
                    }
                    
                    if (col.type === 'dataColumn') {
                        col.subcolumns.map(key => {

                            // Every code in the group is processed — including index 0. For
                            // purely synthetic display names (e.g. "Total", "Package") index 0
                            // has no matching Segment_<code> data and is naturally skipped by
                            // the check below. But for segments whose display name IS itself a
                            // real underlying code (e.g. "BAR", "FIT"), getFromState() moves that
                            // real code to index 0 too — unconditionally skipping index 0 was
                            // silently dropping that segment's real data (table showed a blank
                            // row while the chart, which has no such skip, showed real numbers).
                            marketSegmentsGroup.forEach((segmentCode ) => {
                                let segmentDataOnlyKey = 'Segment_' + segmentCode;

                                if(segmentDataOnly[segmentDataOnlyKey] && segmentDataOnly[segmentDataOnlyKey][mainKey]){
                                    if (key.value == "Occ") {
                                        dataObj[key.value] = dataObj[key.value] ? dataObj[key.value] + convertToPercent( segmentDataOnly[segmentDataOnlyKey][mainKey][key.value]) : convertToPercent( segmentDataOnly[segmentDataOnlyKey][mainKey][key.value]);
                                    }else if (key.value == "Rooms") {
                                        dataObj[key.value] = dataObj[key.value] ? dataObj[key.value] + Math.round( segmentDataOnly[segmentDataOnlyKey][mainKey][key.value]) : Math.round( segmentDataOnly[segmentDataOnlyKey][mainKey][key.value]);
                                    }else if(key.value == "ADR"){
                                        dataObj[key.value] =  dataObj[key.value]? (dataObj[key.value] + segmentDataOnly[segmentDataOnlyKey][mainKey][key.value])/2 :segmentDataOnly[segmentDataOnlyKey][mainKey][key.value];
                                    } else if(key.value == "SellRate"){
                                        dataObj[key.value] = 0;
                                        if(marketSegmentsKey === 'Total'){
                                            dataObj[key.value] = segmentDataOnly['HotelTotal'][mainKey][key.value];
                                        }
                                    }
                                    else {
                                        dataObj[key.value] = dataObj[key.value] ? dataObj[key.value] + segmentDataOnly[segmentDataOnlyKey][mainKey][key.value] : segmentDataOnly[segmentDataOnlyKey][mainKey][key.value];
                                    }
                                }else{
                                    dataObj[key.value] = dataObj[key.value] ? dataObj[key.value] : 0;
                                }
                            })
                        })
                        if(marketSegmentsGroup.length > 2 && dataObj['ADR'] > 0){
                            dataObj['ADR'] =   round(dataObj["Revenue"]  / dataObj["Rooms"] )
                        }
                        if(segmentDataOnly['HotelTotal'][mainKey] && marketSegmentsKey === 'Total'){
                            dataObj['SellRate'] = segmentDataOnly['HotelTotal'][mainKey]['SellRate'];
                        }
                        const htData = segmentDataOnly['HotelTotal']?.[mainKey];
                        const vCapVC = htData?.VCapacity;
                        const vCap = vCapVC || htData?.Capacity;
                        const capacityForCalc = useVarCapacity ? vCap : htData?.Capacity;
                        if (capacityForCalc && dataObj['Rooms'] !== undefined) {
                            dataObj['Occ'] = convertToPercent(dataObj['Rooms'] / capacityForCalc);
                            dataObj['RevPAR'] = round((dataObj['Revenue'] || 0) / capacityForCalc);
                        }
                        if (marketSegmentsKey === 'Total' && vCap) {
                            dataObj._vcap = useVarCapacity ? vCap : htData?.Capacity;
                            dataObj._vcapLabel = (useVarCapacity && vCapVC) ? 'Variable Capacity' : 'Capacity';
                            dataObj._vcapDiffers = !!(vCapVC && vCapVC !== htData?.Capacity);
                        }
                        if (capacityForCalc && marketSegmentsKey === 'Total' && dataObj['Rooms'] !== undefined) {
                            dataObj['Available'] = Math.max(0, round(capacityForCalc - dataObj['Rooms']));
                        } else {
                            dataObj['Available'] = 0;
                        }
                    }
                    segmentGroupRow.push(dataObj);
                    
                })
                if(segmentGroupRow[0].segment !== "IGNORED"){
                    setup_data.push(segmentGroupRow);
                }
                
            })
        })
    }    
    return setup_data;
}

/** get columns for Bi Sensitivity report */
export const getColumnName_biSensitivity = (ord = 3, app_state) => {
    
    let biSensitivity_data = dataService.getSeriesById("BiSensitivity").data;
    let data = (biSensitivity_data) ? biSensitivity_data.data : [];
    const mainColumnn = []
    const subColumns = [];
    // debugger;
    const firstData =  getMaxColumnName();
    let order = ord
    // console.log(Object.keys(firstData).reverse());
    let headerColArr = Object.keys(firstData);
    headerColArr.map((key, keysIndex) => {
        let mainColOrder = keysIndex + 2;
        let keysArr = key.split("_");
        let id = moment(keysArr[2]).format("ddd") + "_" + keysIndex;
        let display = moment(keysArr[2]).format("dddd, MMM Do YYYY");
        display = (keysArr[3] && (app_state.workspace_controls.dayOfWeek === 'mon,tue,wed,thu,fri,sat,sun' || app_state.workspace_controls.dayOfWeek === 'mon,tue,wed,thu' || app_state.workspace_controls.dayOfWeek === 'fri,sat,sun') ) ? display+" - "+moment(keysArr[3]).format("dddd, MMM Do YYYY") : display;
        let mainColObj = {
            "id": id,
            "type": "dataColumn",
            "mainKey": key,
            "tileName": "Report",
            "display": display,
            "backgroundColor": "grey",
            "className": "col-main",
            "draggable": true,
            "hidden": false,
            "colspan": 7,
            "order": mainColOrder,
            "subcolumns": [
                {
                    ...generatDefaultSubcolumns("Rooms", id),
                    "order": 2,
                },
                {
                    ...generatDefaultSubcolumns("Occ", id),
                    "order": 1,
                    "subDisplay": "OOO/OOS"
                },
                {
                    ...generatDefaultSubcolumns("Available", id),
                    "hidden": false,
                    "order": 3,
                    "subDisplay": "",
                },
                {
                    ...generatDefaultSubcolumns("ADR", id),
                    "order": 4
                },
                {
                    ...generatDefaultSubcolumns("RevPAR", id),
                    "order": 5
                },
                {
                    ...generatDefaultSubcolumns("Revenue", id),
                    "order": 6
                },
                {
                    ...generatDefaultSubcolumns("SellRate", id),
                    "order": 7
                }
            ],
        }
        mainColumnn.push(mainColObj);
    })
    return mainColumnn;
}